export default [
  {
    name: 'label.cs',
    label: {
      cs: 'Popisek [CS]',
      en: 'Label [CS]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'label.en',
    label: {
      cs: 'Popisek [EN]',
      en: 'Label [EN]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'color',
    label: {
      cs: 'Barva',
      en: 'Color',
    },
    input: 'select-menu',
    elements: [
      { value: 'blue', label: 'Blue' },
      { value: 'green', label: 'Green' },
      { value: 'purple', label: 'Purple' },
      { value: 'red', label: 'Red' },
      { value: 'yellow', label: 'Yellow' },
    ],
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'icon',
    label: {
      cs: 'Ikona',
      en: 'Icon',
    },
    input: 'input',
    note: 'List',
    link: 'https://fonts.google.com/icons?icon.style=Filled&icon.set=Material+Icons',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'link',
    label: {
      cs: 'Odkaz',
      en: 'Link',
    },
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 128,
    required: true,
  },
];
